module.exports = __webpack_public_path__ + "static/media/envelope-open-dollar.76434450.svg";